export const modalHeader = 'Connect Facebook pages to ';
export const connectHeader = 'Connect Page';
export const grantTitle = `Connect a Partner's Facebook Page`;
export const grantDescription =
  'Have a code from another MobileMonkey account granting you access to their' +
  ' Facebook Page? Paste it below!';
export const defaultSelectAllPageCountThreshold = 20;
